// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import AppWrapper from './App';
import { ThemeProvider } from './components/Utilities/ThemeContext';
import './index.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <ThemeProvider>
        <AppWrapper />
      </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();